import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import RulesetCollection from './ruleset-collection';
import RulesetModel from './ruleset-model';

/** Fetches all rulesets. */
function fetchRulesets() {
  return ajaxService
    .get('/api/xp/ruleset/list?sort=lastUpdated&order=desc')
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(RulesetCollection.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

/** Clones a ruleset. */
function cloneRuleset({ id, name }) {
  return ajaxService
    .post('/api/xp/ruleset/clone', {
      id,
      name,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

/** Creates a ruleset. */
function createRuleset(ruleset) {
  const { name, targetingRules } = RulesetModel.serialize(ruleset);
  return ajaxService
    .post('/api/xp/ruleset/create', {
      name,
      targetingRules,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

/** Updates a ruleset. */
function updateRuleset(ruleset) {
  const { id, name, targetingRules } = RulesetModel.serialize(ruleset);
  return ajaxService
    .post('/api/xp/ruleset/update', {
      id,
      name,
      targetingRules,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

/** Deletes rulesets by ID. */
function deleteRulesets({ ids }) {
  return ajaxService
    .post('/api/xp/ruleset/deleteList', {
      ids: ids.join(','),
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch(ApiUtils.extractFailedError);
}

export default {
  fetchRulesets,
  cloneRuleset,
  createRuleset,
  updateRuleset,
  deleteRulesets,
};
